module.exports = __webpack_public_path__ + "assets/img/1.a78feed4.webp";